import { render } from "./ActionMessage.vue?vue&type=template&id=bcb26626"
import script from "./ActionMessage.vue?vue&type=script&lang=js"
export * from "./ActionMessage.vue?vue&type=script&lang=js"
script.render = render
/* hot reload */
if (module.hot) {
  script.__hmrId = "bcb26626"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('bcb26626', script)) {
    api.reload('bcb26626', script)
  }
  
  module.hot.accept("./ActionMessage.vue?vue&type=template&id=bcb26626", () => {
    api.rerender('bcb26626', render)
  })

}

script.__file = "resources/js/Jetstream/ActionMessage.vue"

export default script